import Config from "../../config";
import Document from "../general/document";

export interface InvitationData {
  code: string;
  createdAt: Date;
  phone?: string;
  userId?: string;
}

export type InvitationStatus = "invited" | "active" | "inactive";

class Invitation extends Document<InvitationData> {
  get code() {
    return this.data.code;
  }
  get phone() {
    return this.data.phone;
  }
  get userId() {
    return this.data.userId;
  }
  get status(): InvitationStatus {
    return this.data.phone ? "active" : "invited";
  }
  get deeplink() {
    const config = Config.dynamicLink;
    const link = `${window.location.origin}/invitation/${this.code}`;
    return `https://${config.domain}/?link=${link}&apn=${config.packageName}&ibi=${config.bundleId}`;
  }

  // async remove() {
  //   if (this.user.docs.length > 0) {
  //     await Promise.all(this.user.docs.map((user) => user.delete()));
  //   }
  //   await this.delete();
  // }
}

export default Invitation;
